module.exports = __webpack_public_path__ + "static/img/notice.fd3cdd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/notice.png
// module id = 3GzM
// module chunks = 19